import React, { useState } from "react";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import PageHero from "../components/PageHero";
import { siteMeta } from "../data/siteContent";

function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    subject: "",
    message: "",
  });

  const onChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    setFormData({ name: "", contact: "", subject: "", message: "" });
  };

  return (
    <>
      <PageHero
        eyebrow="Contact"
        title="Get in Touch"
        intro="If you have questions about the church, the gospel, or visiting, we would be glad to hear from you."
        metaTitle={`Contact | ${siteMeta.churchName}`}
      />
      <section className="site-section">
        <Container>
          <Row className="g-5 align-items-start">
            <Col lg={5}>
              <div className="content-panel">
                <h2>Church Information</h2>
                <ul className="contact-meta">
                  <li>
                    <strong>Address</strong>
                    <span>{siteMeta.address}</span>
                  </li>
                  <li>
                    <strong>Phone</strong>
                    <span>{siteMeta.phone}</span>
                  </li>
                  <li>
                    <strong>Email</strong>
                    <span>{siteMeta.email}</span>
                  </li>
                  <li>
                    <strong>Sunday gathering</strong>
                    <span>{siteMeta.serviceTime}</span>
                  </li>
                </ul>
                <div className="site-footer__socials site-footer__socials--dark">
                  <a href={siteMeta.youtube} target="_blank" rel="noreferrer">
                    YouTube
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noreferrer">
                    Instagram
                  </a>
                  <a href="https://facebook.com" target="_blank" rel="noreferrer">
                    Facebook
                  </a>
                </div>
              </div>
              <div className="map-frame">
                <iframe
                  title="Church map"
                  src={siteMeta.mapEmbed}
                  loading="lazy"
                  allowFullScreen
                ></iframe>
              </div>
            </Col>
            <Col lg={7}>
              <div className="content-panel">
                <h2>Send a Message</h2>
                {submitted ? (
                  <Alert variant="success" onClose={() => setSubmitted(false)} dismissible>
                    Thank you for your message. We appreciate your interest and will follow up.
                  </Alert>
                ) : null}
                <Form onSubmit={onSubmit} className="site-form">
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      required
                      name="name"
                      value={formData.name}
                      onChange={onChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Email or phone</Form.Label>
                    <Form.Control
                      required
                      name="contact"
                      value={formData.contact}
                      onChange={onChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Subject</Form.Label>
                    <Form.Control
                      required
                      name="subject"
                      value={formData.subject}
                      onChange={onChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      required
                      name="message"
                      value={formData.message}
                      onChange={onChange}
                    />
                  </Form.Group>
                  <Button type="submit" className="site-button site-button--primary">
                    Submit
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default ContactPage;
